import { map } from 'lodash';

export enum COOPERATION_STATE {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
}

export const COOPERATION_STATE_LABEL: Record<COOPERATION_STATE, string> = {
  [COOPERATION_STATE.ACTIVE]: '合作中',
  [COOPERATION_STATE.INACTIVE]: '已終止',
  [COOPERATION_STATE.PENDING]: '待確認',
};

export const COOPERATION_STATE_COLOR: Record<COOPERATION_STATE, string> = {
  [COOPERATION_STATE.ACTIVE]: 'text-green-500',
  [COOPERATION_STATE.INACTIVE]: 'text-red-500',
  [COOPERATION_STATE.PENDING]: 'text-yellow-500',
};

export const LOCATION_COOPERATION_STATE_OPTIONS = map(
  [COOPERATION_STATE.ACTIVE, COOPERATION_STATE.INACTIVE],
  (state) => ({
    label: COOPERATION_STATE_LABEL[state],
    value: state,
  })
);
